<script>
// Custom Components
import PageHeader from "@/components/page-header";
import errorHandler from "@/helpers/errorHandler";
import iotService from "@/helpers/APIService/iot.service";
import appConfig from "@/app.config";

export default {
  page: {
    title: "device",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      items: [
        {
          text: "Gateway",
          to: { path: "/gateway-list" },
        },
        {
          text: "Device",
          active: false,
        },
      ],
      title: "List Of IOT Device",
      isLoading: false,
      devices: [],
      isMoodalLoading: false,
      selectedData: null,
    };
  },
  computed: {
    deviceProps() {
      return {
        deviceId: this.deviceId,
        isEdit: this.isEdit,
        device: this.device,
      };
    },
  },
  components: {
    PageHeader,
  },
  mounted() {
    this.getDevices();
  },
  methods: {
    // Method is used to get device list
    async getDevices() {
      this.isLoading = true;
      try {
        const response = await iotService.getLockDeviceList(
          this.$route.params.id
        );
        if (response) {
          this.devices = response;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get back to gateway list
    backGateway() {
      this.$router.go(-1);
    },
    displayDeviceData(data) {
      data.config_data = {
        ...data.config_data,
        ...data.config_data.master_data,
      };
      delete data.config_data.master_data;
      this.selectedData = data;
      this.$refs["device-data-modal"].show();
    },
    resetModal() {
      this.$refs["device-data-modal"].hide();
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <v-table
            :data="devices"
            class="table table-hover mb-0"
            ref="my-table"
          >
            <thead class="table-light" slot="head">
              <tr>
                <v-th sortKey="device_name">Device Name</v-th>
                <v-th sortKey="connect_room.room_number">Connected Room</v-th>
                <v-th sortKey="iot_device_model.name">Device Model</v-th>
                <v-th sortKey="device_address">Device Address</v-th>
                <v-th sortKey="iot_device_model.device_type">Device Type</v-th>
                <th>Timestamp</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody
              class="infinite-list"
              slot="body"
              slot-scope="{ displayData }"
              v-if="!isLoading && devices.length !== 0"
            >
              <tr
                v-for="(device, index) in displayData"
                :key="index"
                @click="displayDeviceData(device)"
              >
                <td>
                  {{ device.device_name }}
                </td>
                <td>
                  <span>
                    {{
                      device.connect_room
                        ? device.connect_room.room_number
                        : "-"
                    }}
                  </span>
                </td>
                <td>
                  {{
                    device.iot_device_model !== null
                      ? device.iot_device_model.name
                      : "-"
                  }}
                </td>
                <td>
                  {{
                    device.device_address !== null ? device.device_address : "-"
                  }}
                </td>
                <td>
                  {{
                    device.iot_device_model !== null
                      ? device.iot_device_model.device_type.replaceAll("_", " ")
                      : "-"
                  }}
                </td>
                <td>
                  {{
                    global_format_date_and_time_custom(
                      device.created_at,
                      "YYYY-MM-DD hh:mm A"
                    )
                  }}
                </td>
                <td>
                  <div class="overflow-tip">
                    <span>
                      {{ device.remark !== null ? device.remark : "-" }}</span
                    >
                  </div>
                </td>
                <td>
                  <div class="form-check form-switch my-1" slot="is_active">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="device.is_active"
                      disabled
                    />
                  </div>
                </td>
                <td><i class="mdi mdi-eye fs-5 text-success"></i></td>
              </tr>
            </tbody>
            <tbody slot="body" v-else-if="isLoading">
              <tr v-for="item in 10" :key="item">
                <td class="placeholder-glow" v-for="no in 9" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody slot="body" v-else>
              <tr>
                <td colspan="9" class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>
    </div>

    <b-modal
      id="device-data-modal"
      centered
      :title="`
        (${
          selectedData &&
          selectedData.connect_room &&
          selectedData.connect_room.room_number
            ? 'ROOM - ' + selectedData.connect_room.room_number
            : ''
        }- ${selectedData ? 'DEVICE - ' + selectedData.device_name : ''})
        - CONFIGURATION DATA`"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      ref="device-data-modal"
      size="xl"
    >
      <div class="col-md-12" v-if="selectedData">
        <div class="row">
          <div
            class="col-md-4"
            v-for="(item, key, index) in selectedData.config_data"
            :key="index"
          >
            <h5 class="font-size-14 text-capitalize">
              {{ key }}
            </h5>
            <p class="mb-1 text-dark text-capitalize">
              {{ item ? item : "-" }}
            </p>
            <div class="command-lock-border my-12 mb-1" />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.command-lock-border {
  border-bottom: 1px dashed #d5d5d5;
}
</style>
